import { render, staticRenderFns } from "./manageOffers.vue?vue&type=template&id=5fc222ab&"
import script from "./manageOffers.vue?vue&type=script&lang=js&"
export * from "./manageOffers.vue?vue&type=script&lang=js&"
import style0 from "./manageOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports